<template>
    <div class="navs">
        <div @click="switchNav(item, index)" class="nav-item" v-for="(item, index) in navs" :key="item.title" ref="childWrap">
            <span :class="{ 'active' : index === curIndex}">{{ item.title }}</span>
            <span class="line"></span>
            <section class="child-wrap" v-if="showChildWrap && index === indexForShowChild && item.children && item.children.length">
                <div @click="switchChild(child, cIndex)" :class="['item', {'active-child' : cIndex === curChildIndex && curIndex === index}]" v-for="(child, cIndex) in item.children" :key="child.title">{{ child.title }}</div>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'navs',
    props: {
		navs: {
			type: Array,
			default: () => ([])
        },
        activeIndex: {
			type: Number,
			default: -1
        },
        activeChildIndex: {
			type: Number,
			default: -1
        }
	},
     watch: {
        activeIndex (val) {
            if(val > -1) {
                this.curIndex = val
            }
        },
        activeChildIndex (val) {
            if(val > -1) {
                this.curChildIndex = val
            }
        }
    },
    data() {
        return {
            curNav: this.navs[0] || null,
            curChild: null,
            curIndex: -1,
            curChildIndex: -1,
            showChildWrap: false,
            indexForShowChild: -1
        }
    },
    created() {
        this.curIndex = this.activeIndex
        this.curChildIndex = this.activeChildIndex
        document.addEventListener('click', this.closeComponent)
    },
    methods: {
        switchNav(item, index) {
            if(item.children && item.children.length) {
                this.indexForShowChild = index
                return this.showChildWrap = true
            }
            this.curNav = item
            this.curIndex = index
            this.showChildWrap = false
            this.indexForShowChild = -1
            this.curChild = null
            this.curChildIndex = -1
            this.$emit('on-switch', {
                item: this.curNav,
                index: this.curIndex,
                childIndex: -1,
                child: null
            })
        },
        switchChild(item, index) {
            this.curNav = this.navs[this.indexForShowChild]
            this.curIndex = this.indexForShowChild
            this.curChild = item
            this.curChildIndex = index
            this.showChildWrap = false
            this.indexForShowChild = -1
            this.$emit('on-switch', {
                item: this.curNav,
                index: this.curIndex,
                childIndex: this.curChildIndex,
                child: this.curChild
            })
        },
        closeComponent(e) {
                if (
                    (this.$refs.childWrap[this.indexForShowChild] && this.$refs.childWrap[this.indexForShowChild].$el && !this.$refs.childWrap[this.indexForShowChild].$el.contains(e.target)) ||
                    (this.$refs.childWrap[this.indexForShowChild] && this.$refs.childWrap[this.indexForShowChild].contains && !this.$refs.childWrap[this.indexForShowChild].contains(e.target))
                ) {
                    this.showChildWrap = false
                    // this.indexForShowChild = -1
                }
        }
    }
}
</script>

<style lang="scss" scoped>
    .navs {
        display: flex;
        flex-wrap: wrap;
        background: #f1f1f1;
            display: flex;
            flex-wrap: wrap;
            .nav-item {
                font-size: .36rem;
                position: relative;
                width: 33.33%;
                margin: .2rem 0;
                font-weight: bold;
                text-align: center;
                position: relative;
                /* border-right: 1px solid #333; */
                .line {
                    width: 0.01rem;
                    height: .3rem;
                    display: inline-block;
                    position: absolute;
                    background: #333;
                    right: 0;
                    top: 50%;
                    margin-top: -.15rem;
                }
                &:nth-child(3n) {
                   .line {
                       display: none;
                   }
                }
                .active {
                    color: #dc1e32;
                    border-bottom: .04rem solid #dc1e32;
                }
                .child-wrap {
                    background-color: #fff;
                    position: absolute;
                    width: 100%;
                    z-index: 3;
                    top: .74rem;
                    border: 1px solid #e5e5e5;
                    border-top: none;
                    width: calc(100% + 1px);
                    .item {
                        height: .8rem;
                        line-height: .8rem;
                        font-size: .24rem;
                        color: #333;
                        font-weight: normal;
                        &.active-child {
                            color: #dc1e32;
                        }
                    }
                }
            }
    }
</style>



// WEBPACK FOOTER //
// src/components/navs/index.vue